import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';

import { ctw } from '@/common';
import { useForceExpandAccordions } from '@/common/providers/PrintContext';

export const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => {
  // Print safety net: when rendered under a PrintContextProvider that asks for
  // expansion (the server-side PDF route), keep the content mounted even while
  // its item is collapsed and tag it so the print stylesheet can reveal it.
  // This way a NEW accordion built from these shared primitives is expanded in
  // the PDF automatically — the section author doesn't have to remember to wire
  // `useForceExpandAccordions()` / `defaultValue` at the call site. Outside a
  // print page the context is `false`, so this is a no-op for normal app usage.
  const forceExpandAccordions = useForceExpandAccordions();

  return (
    <AccordionPrimitive.Content
      ref={ref}
      forceMount={forceExpandAccordions || undefined}
      data-print-expanded={forceExpandAccordions || undefined}
      className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm"
      {...props}
    >
      <div className={ctw('pb-4 pt-0', className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
});

AccordionContent.displayName = AccordionPrimitive.Content.displayName;
